import { ItemListContainer, ItemWrapper, ItemInfoWrapper, ItemTitleWrapper, ColumnWrapper, ItemLeftWrapper, ItemActionsWrapper } from "./TaskItemList.styled";
import { Typography, Button, Tag } from "@ann/web-components";



const TaskItem = ({ info }) => {
    return (
        <ItemListContainer>
            <ItemWrapper>
                <ItemLeftWrapper>
                    <ItemTitleWrapper>
                        <Typography category='subtitle' weight='bold' size='medium' color='subtitle' >{info.type}</Typography>
                    </ItemTitleWrapper>
                    <ItemInfoWrapper>
                        <ColumnWrapper>
                            <Typography category='subtitle' weight='bold' size='small' color='subtitle'>
                                Description
                            </Typography>
                            <Typography category='body' weight='regular' size='small' color='body' maxCharacters={15}>
                                {info.description}
                            </Typography>
                        </ColumnWrapper>
                        <ColumnWrapper>
                            <Typography category='subtitle' weight='bold' size='small' color='subtitle'>
                                Category
                            </Typography>
                            <Typography category='body' weight='regular' size='small' color='body' maxCharacters={15}>
                                {info.category}
                            </Typography>
                        </ColumnWrapper>
                        <ColumnWrapper>
                            <Typography category='subtitle' weight='bold' size='small' color='subtitle'>
                                Status
                            </Typography>
                            <Tag text={info.status} color={info.status === "Pending" ? "alert" : "success"} size='small' />
                        </ColumnWrapper>
                        <ColumnWrapper>
                            <Typography category='subtitle' weight='bold' size='small' color='subtitle'>
                                Timestamp
                            </Typography>
                            <Typography category='body' weight='regular' size='small' color='body' maxCharacters={15}>
                                {info.timestamp}
                            </Typography>
                        </ColumnWrapper>
                    </ItemInfoWrapper>
                </ItemLeftWrapper>
                <ItemActionsWrapper>
                    <Button size='small' type={info.status === "Pending" ? "primary" : "secondary"} pill={true} label={info.status === "Pending" ? "Complete" : "Undo"} />
                </ItemActionsWrapper>
            </ItemWrapper>
        </ItemListContainer>
    )
}

export default TaskItem;